import React from "react";
// import About from "./about-us/index";
// import Features from "../components/Features";
// import WhyUs from "../components/WhyUs";
import Contact from "../components/Contact";
// import Partners from "../components/Partners";
import Home from "components/Home";
// import AboutUs from "../components/AboutUs";
// import Team from "../components/Team";
import OurCollaborators from "../components/OurCollaborators";
import OurServices from "../components/OurServices";
import RecentArticles from "../components/RecentArticles";
import Testimonials from "../components/Testimonials";

const IndexPage = () => {
  return (
    <React.Fragment>
      <Home />
      {/* <About /> */}
      {/* <Features /> */}
      {/* <WhyUs /> */}
      {/* <Team /> */}
      {/* <Partners /> */}
      {/* <AboutUs /> */}
      {/* <Features /> */}
      {/* <WhyUs /> */}
      <OurServices />
      <OurCollaborators />
      <RecentArticles />
      <Testimonials />
      <Contact />
    </React.Fragment>
  );
};

export default IndexPage;
